export default __webpack_public_path__ + "static/media/box2.624f9f1e.svg";